import _asyncToGenerator from "/home/vsts/work/1/s/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { clonePseudoElements } from './clone-pseudos';
import { createImage, toArray, isInstanceOfElement } from './util';
import { getMimeType } from './mimes';
import { resourceToDataURL } from './dataurl';
function cloneCanvasElement(_x) {
  return _cloneCanvasElement.apply(this, arguments);
}
function _cloneCanvasElement() {
  _cloneCanvasElement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(canvas) {
    var dataURL;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dataURL = canvas.toDataURL();
          if (!(dataURL === 'data:,')) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", canvas.cloneNode(false));
        case 3:
          return _context.abrupt("return", createImage(dataURL));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _cloneCanvasElement.apply(this, arguments);
}
function cloneVideoElement(_x2, _x3) {
  return _cloneVideoElement.apply(this, arguments);
}
function _cloneVideoElement() {
  _cloneVideoElement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(video, options) {
    var canvas, ctx, _dataURL, poster, contentType, dataURL;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!video.currentSrc) {
            _context2.next = 8;
            break;
          }
          canvas = document.createElement('canvas');
          ctx = canvas.getContext('2d');
          canvas.width = video.clientWidth;
          canvas.height = video.clientHeight;
          ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          _dataURL = canvas.toDataURL();
          return _context2.abrupt("return", createImage(_dataURL));
        case 8:
          poster = video.poster;
          contentType = getMimeType(poster);
          _context2.next = 12;
          return resourceToDataURL(poster, contentType, options);
        case 12:
          dataURL = _context2.sent;
          return _context2.abrupt("return", createImage(dataURL));
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _cloneVideoElement.apply(this, arguments);
}
function cloneIFrameElement(_x4) {
  return _cloneIFrameElement.apply(this, arguments);
}
function _cloneIFrameElement() {
  _cloneIFrameElement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(iframe) {
    var _a;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          if (!((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
            _context3.next = 5;
            break;
          }
          _context3.next = 4;
          return cloneNode(iframe.contentDocument.body, {}, true);
        case 4:
          return _context3.abrupt("return", _context3.sent);
        case 5:
          _context3.next = 9;
          break;
        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](0);
        case 9:
          return _context3.abrupt("return", iframe.cloneNode(false));
        case 10:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 7]]);
  }));
  return _cloneIFrameElement.apply(this, arguments);
}
function cloneSingleNode(_x5, _x6) {
  return _cloneSingleNode.apply(this, arguments);
}
function _cloneSingleNode() {
  _cloneSingleNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(node, options) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!isInstanceOfElement(node, HTMLCanvasElement)) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return", cloneCanvasElement(node));
        case 2:
          if (!isInstanceOfElement(node, HTMLVideoElement)) {
            _context4.next = 4;
            break;
          }
          return _context4.abrupt("return", cloneVideoElement(node, options));
        case 4:
          if (!isInstanceOfElement(node, HTMLIFrameElement)) {
            _context4.next = 6;
            break;
          }
          return _context4.abrupt("return", cloneIFrameElement(node));
        case 6:
          return _context4.abrupt("return", node.cloneNode(false));
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _cloneSingleNode.apply(this, arguments);
}
var isSlotElement = function isSlotElement(node) {
  return node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
};
function cloneChildren(_x7, _x8, _x9) {
  return _cloneChildren.apply(this, arguments);
}
function _cloneChildren() {
  _cloneChildren = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(nativeNode, clonedNode, options) {
    var _a, _b, children;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          children = [];
          if (isSlotElement(nativeNode) && nativeNode.assignedNodes) {
            children = toArray(nativeNode.assignedNodes());
          } else if (isInstanceOfElement(nativeNode, HTMLIFrameElement) && ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
            children = toArray(nativeNode.contentDocument.body.childNodes);
          } else {
            children = toArray(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
          }
          if (!(children.length === 0 || isInstanceOfElement(nativeNode, HTMLVideoElement))) {
            _context5.next = 4;
            break;
          }
          return _context5.abrupt("return", clonedNode);
        case 4:
          _context5.next = 6;
          return children.reduce(function (deferred, child) {
            return deferred.then(function () {
              return cloneNode(child, options);
            }).then(function (clonedChild) {
              if (clonedChild) {
                clonedNode.appendChild(clonedChild);
              }
            });
          }, Promise.resolve());
        case 6:
          return _context5.abrupt("return", clonedNode);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _cloneChildren.apply(this, arguments);
}
function cloneCSSStyle(nativeNode, clonedNode) {
  var targetStyle = clonedNode.style;
  if (!targetStyle) {
    return;
  }
  var sourceStyle = window.getComputedStyle(nativeNode);
  if (sourceStyle.cssText) {
    targetStyle.cssText = sourceStyle.cssText;
    targetStyle.transformOrigin = sourceStyle.transformOrigin;
  } else {
    toArray(sourceStyle).forEach(function (name) {
      var value = sourceStyle.getPropertyValue(name);
      if (name === 'font-size' && value.endsWith('px')) {
        var reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
        value = "".concat(reducedFont, "px");
      }
      if (isInstanceOfElement(nativeNode, HTMLIFrameElement) && name === 'display' && value === 'inline') {
        value = 'block';
      }
      if (name === 'd' && clonedNode.getAttribute('d')) {
        value = "path(".concat(clonedNode.getAttribute('d'), ")");
      }
      targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
  }
}
function cloneInputValue(nativeNode, clonedNode) {
  if (isInstanceOfElement(nativeNode, HTMLTextAreaElement)) {
    clonedNode.innerHTML = nativeNode.value;
  }
  if (isInstanceOfElement(nativeNode, HTMLInputElement)) {
    clonedNode.setAttribute('value', nativeNode.value);
  }
}
function cloneSelectValue(nativeNode, clonedNode) {
  if (isInstanceOfElement(nativeNode, HTMLSelectElement)) {
    var clonedSelect = clonedNode;
    var selectedOption = Array.from(clonedSelect.children).find(function (child) {
      return nativeNode.value === child.getAttribute('value');
    });
    if (selectedOption) {
      selectedOption.setAttribute('selected', '');
    }
  }
}
function decorate(nativeNode, clonedNode) {
  if (isInstanceOfElement(clonedNode, Element)) {
    cloneCSSStyle(nativeNode, clonedNode);
    clonePseudoElements(nativeNode, clonedNode);
    cloneInputValue(nativeNode, clonedNode);
    cloneSelectValue(nativeNode, clonedNode);
  }
  return clonedNode;
}
function ensureSVGSymbols(_x10, _x11) {
  return _ensureSVGSymbols.apply(this, arguments);
}
function _ensureSVGSymbols() {
  _ensureSVGSymbols = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(clone, options) {
    var uses, processedDefs, i, use, id, exist, definition, nodes, ns, svg, defs, _i;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          uses = clone.querySelectorAll ? clone.querySelectorAll('use') : [];
          if (!(uses.length === 0)) {
            _context6.next = 3;
            break;
          }
          return _context6.abrupt("return", clone);
        case 3:
          processedDefs = {};
          i = 0;
        case 5:
          if (!(i < uses.length)) {
            _context6.next = 18;
            break;
          }
          use = uses[i];
          id = use.getAttribute('xlink:href');
          if (!id) {
            _context6.next = 15;
            break;
          }
          exist = clone.querySelector(id);
          definition = document.querySelector(id);
          if (!(!exist && definition && !processedDefs[id])) {
            _context6.next = 15;
            break;
          }
          _context6.next = 14;
          return cloneNode(definition, options, true);
        case 14:
          processedDefs[id] = _context6.sent;
        case 15:
          i++;
          _context6.next = 5;
          break;
        case 18:
          nodes = Object.values(processedDefs);
          if (nodes.length) {
            ns = 'http://www.w3.org/1999/xhtml';
            svg = document.createElementNS(ns, 'svg');
            svg.setAttribute('xmlns', ns);
            svg.style.position = 'absolute';
            svg.style.width = '0';
            svg.style.height = '0';
            svg.style.overflow = 'hidden';
            svg.style.display = 'none';
            defs = document.createElementNS(ns, 'defs');
            svg.appendChild(defs);
            for (_i = 0; _i < nodes.length; _i++) {
              defs.appendChild(nodes[_i]);
            }
            clone.appendChild(svg);
          }
          return _context6.abrupt("return", clone);
        case 21:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _ensureSVGSymbols.apply(this, arguments);
}
export function cloneNode(_x12, _x13, _x14) {
  return _cloneNode.apply(this, arguments);
}
function _cloneNode() {
  _cloneNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(node, options, isRoot) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          if (!(!isRoot && options.filter && !options.filter(node))) {
            _context7.next = 2;
            break;
          }
          return _context7.abrupt("return", null);
        case 2:
          return _context7.abrupt("return", Promise.resolve(node).then(function (clonedNode) {
            return cloneSingleNode(clonedNode, options);
          }).then(function (clonedNode) {
            return cloneChildren(node, clonedNode, options);
          }).then(function (clonedNode) {
            return decorate(node, clonedNode);
          }).then(function (clonedNode) {
            return ensureSVGSymbols(clonedNode, options);
          }));
        case 3:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _cloneNode.apply(this, arguments);
}